// The grammar lives in @paisa/finance/calc (shared with the phone); this wraps it with the web's English
// error text so the composer keeps showing plain sentences.
import {
  MAX_DESCRIPTION_LENGTH,
  type QuickAddParse as Parsed,
  parseQuickAdd as parse,
  type QuickAddError,
} from "@paisa/finance/calc"

export type { GrammarCategory, GrammarPerson } from "@paisa/finance/calc"
export type QuickAddParse = Omit<Parsed, "errors"> & { errors: string[] }

const message = (e: QuickAddError): string =>
  ({
    no_amount: "Add an amount, e.g. 450.",
    zero_amount: "The amount must be more than 0.",
    no_description: "Add what it was for, e.g. swiggy.",
    bad_date: `"${e.token}" isn't a date.`,
    too_long: `Keep what it was for to ${MAX_DESCRIPTION_LENGTH} characters or fewer.`,
  })[e.code]

export function parseQuickAdd(...args: Parameters<typeof parse>): QuickAddParse {
  const r = parse(...args)
  return { ...r, errors: r.errors.map(message) }
}
